module.exports = __webpack_public_path__ + "img/store-product.374ff3ac.png";